import { render, staticRenderFns } from "./treeTransfer.vue?vue&type=template&id=664ce7ad&scoped=true"
import script from "./treeTransfer.vue?vue&type=script&lang=js"
export * from "./treeTransfer.vue?vue&type=script&lang=js"
import style0 from "./treeTransfer.vue?vue&type=style&index=0&id=664ce7ad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@5.2.7_vue-template-compiler@2.6.14_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664ce7ad",
  null
  
)

export default component.exports